// import axios from 'axios'; // axios
import * as types from '../mutation-types';
import { doGet } from '@/axios/http';

const state = {
  loading: {
    hjType: false,
    xjFields: false,
    wxStatus: false,
    preconditionCate: false,
    feeStatus: false,
    rollChangeStatus: false,
    rollOutStatus: false,
    exportfields: false,
    sealStatus: false,
    contractSecret: false,
    contractFundflow: false,
    contractIdentity: false,
    check: false,
    logstype: false,
    orderStatus: false,
    sitetype: false,
    companyStatus: false,
    qingkuancate: false,
    tichengstatus: false,
  },
  hjType: {},
  xjFields: {},
  wxStatus: {},
  preconditionCate: {},
  feeStatus: {},
  rollChangeStatus: {},
  rollOutStatus: {},
  exportfields: {},
  sealStatus: {},
  contractSecret: {},
  contractFundflow: {},
  contractIdentity: {},
  check: {},
  logstype: {},
  orderStatus: {},
  sitetype: {},
  companyStatus: {},
  qingkuancate: {},
  tichengstatus: {},
};

const getters = {
  [types.STATUS.statusLoading]: (state) => {
    return state.loading;
  },
  [types.STATUS.hjType]: (state) => {
    return state.hjType;
  },
  [types.STATUS.xjFields]: (state) => {
    return state.xjFields;
  },
  [types.STATUS.wxStatus]: (state) => {
    return state.wxStatus;
  },
  [types.STATUS.preconditionCate]: (state) => {
    return state.preconditionCate;
  },
  [types.STATUS.feeStatus]: (state) => {
    return state.feeStatus;
  },
  [types.STATUS.rollChangeStatus]: (state) => {
    return state.rollChangeStatus;
  },
  [types.STATUS.rollOutStatus]: (state) => {
    return state.rollOutStatus;
  },
  [types.STATUS.exportfields]: (state) => {
    return state.exportfields || {};
  },
  [types.STATUS.sealStatus]: (state) => {
    return state.sealStatus;
  },
  [types.STATUS.contractSecret]: (state) => {
    return state.contractSecret;
  },
  [types.STATUS.contractFundflow]: (state) => {
    return state.contractFundflow;
  },
  [types.STATUS.contractIdentity]: (state) => {
    return state.contractIdentity;
  },
  [types.STATUS.check]: (state) => {
    return state.check;
  },
  [types.STATUS.logstype]: (state) => {
    return state.logstype;
  },
  [types.STATUS.orderStatus]: (state) => {
    return state.orderStatus;
  },
  [types.STATUS.sitetype]: (state) => {
    return state.sitetype;
  },
  [types.STATUS.companyStatus]: (state) => {
    return state.companyStatus;
  },
  [types.STATUS.qingkuancate]: (state) => {
    return state.qingkuancate;
  },
  [types.STATUS.tichengstatus]: (state) => {
    return state.tichengstatus;
  },
};

const mutations = {
  setState(state, args) {
    state[args.type] = args.json;
    state.loading[args.loading] = false;
  },
}

const actions = {
  loadStatus({ commit, state, rootState }, param) {
    // console.log(param)
    if (!param.type || state.loading[param.type] === undefined) {
      param && param.callback && (param.callback.call(this, 'Missing type parameters!'));
    } else {
      state.loading[param.type] = true;
      doGet({
        url: 'sys/code/loadStatus/'+ param.type,
        headers: { Authorization: rootState.token },
        okcb: (json) => {
          commit('setState', {type: param.type, loading: param.type || param.loading, json: json || {}});
        },
        errcb: (data) => {
          param && param.callback && (param.callback.call(this, data || '服务器错误！'));
          state.loading[param.type] = false;
        }
      });
      // axios.get('/api/sys/code/loadStatus/'+ param.type, {headers: {Authorization: rootState.token}})
      //     .then((response) => {
      //       const json = response.data;
      //       if (json && json[types.KEY_STATUS] === types.CODE_SUCCESS) {
      //         commit('setState', {type: param.type, loading: param.type || param.loading, json: json.obj || {}})
      //         // commit(param.obj, {});
      //         // if (json.obj) {
      //         //   commit(param.obj, json.obj);
      //         // }
      //       } else {
      //         param && param.callback && (param.callback.call(this, json || '服务器错误！'));
      //         state.loading[param.type] = false;
      //       }
      //     })
      //     .catch((response) => {
      //       param && param.callback && (param.callback.call(this, response.data || '服务器错误！'));
      //       state.loading[param.type] = false;
      //     });
    }
  },
  [types.STATUS.hjType] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'hjType', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.xjFields] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'xjFields', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.wxStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'wxStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.preconditionCate] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'preconditionCate', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.feeStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'feeStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.rollChangeStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'rollChangeStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.rollOutStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'rollOutStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.exportfields] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'exportfields', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.sealStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'sealStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.contractSecret] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'contractSecret', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.contractFundflow] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'contractFundflow', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.contractIdentity] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'contractIdentity', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.check] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'check', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.logstype] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'logstype', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.orderStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'orderStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.sitetype] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'sitetype', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.companyStatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'companyStatus', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.qingkuancate] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'qingkuancate', obj: true});
    dispatch('loadStatus', param);
  },
  [types.STATUS.tichengstatus] ({ dispatch }, param = {}) {
    Object.assign(param, {type:'tichengstatus', obj: true});
    dispatch('loadStatus', param);
  },
}

export default {
  state,
  getters,
  mutations,
  actions
}
